import { Button } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../../shared/components/variables';

export const PaginationIcon = styled(Button)`
  min-width: unset;
  width: 40px;
  height: 40px;
  color: ${colorTokens.text.primary} !important;

  &:disabled {
    color: ${colorTokens.text.disabled} !important;
  }
`;

export const PaginationPage = styled(Button)`
  min-width: unset;
  width: 40px;
  height: 40px;
  color: ${colorTokens.text.primary} !important;
  background-color: transparent !important;
  border: 0 !important;
  outline: none !important;

  &.active {
    background-color: rgba(0, 0, 0, 0.08) !important;
  }
`;
